import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import './info_icon.css';

interface InfoIconProps {
  popupText: string;
}

const InfoIcon: React.FC<InfoIconProps> = ({ popupText }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [anchor, setAnchor] = useState<DOMRect | null>(null);

  const handleClick = (e: React.MouseEvent) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setAnchor(rect);
    setShowPopup(!showPopup);
  };

  const viewportHeight = window.innerHeight;

  const popup = showPopup && anchor
    ? ReactDOM.createPortal(
        <div
          className="popup-portal"
          style={{
            position: 'fixed',
            top: anchor.bottom + 150 > viewportHeight
              ? anchor.top - 110 // show above if too low
              : anchor.bottom + 8, // otherwise below
            left: anchor.left + anchor.width / 2 - 100,
            width: '200px',
          }}
        >
          <p>{popupText}</p>
          <button onClick={() => setShowPopup(false)}>OK</button>
        </div>,
        document.body
      )
    : null;

  return (
    <>
      <span
        className="info-icon"
        onClick={handleClick}
        title="Kliknutím zobrazíte více informací"
      >
        ℹ️
      </span>
      {popup}
    </>
  );
};

export default InfoIcon;
